export let postRollFilters = function () {

  // Keyboard navigation functionality
  document.onkeydown = function(e) {
    e = e || window.event;
    var isEscape = false;
    if ("key" in e) {
        isEscape = (e.key === "Escape" || e.key === "Esc");
    } else {
        isEscape = (e.keyCode === 27);
    }
    if (isEscape && $('#post_roll_filters').hasClass('active') || isEscape && $('#all-companies-filters').hasClass('active')) {
      $('#post_roll_filters').removeClass('active');
      $('#all-companies-filters').removeClass('active');
      $('.top-level-mobile-filter-container').removeClass('hide');
    }
  };

  // Function to update URL parameters when clicking a filter button
  let updateURLParam = function(activeFilterParam, activeFilterType) {

    let currentURL = window.location.href;
    let activeFilterVar = activeFilterParam; 

    if (currentURL.indexOf("?") == -1) {
      let newURL = currentURL + `?${activeFilterType}=${activeFilterVar}`;
      window.history.pushState({}, null, newURL);
    } else {
      currentURL = currentURL.split("?");
      currentURL = currentURL[0];
      let newURL = currentURL + `?${activeFilterType}=${activeFilterVar}`;
      window.history.pushState({}, null, newURL);
    }
  }

  let showPosts = function(data) {

    dayshift_loadmore_params.current_page = 1;
    dayshift_loadmore_params.max_page = data.max_page;
    dayshift_loadmore_params.query_vars = data.query_vars;

    //console.log('show posts query vars ' + data.query_vars);

    $("#postsContainer.post-roll-grid").html(data.content);

    if(dayshift_loadmore_params.current_page === dayshift_loadmore_params.max_page || dayshift_loadmore_params.max_page == 0) {
      $('.loadmore-wrapper').hide();
    } else {
      $('.loadmore-wrapper').show();
      $('.loadmore-wrapper button').removeClass('hide');
    }

    if(dayshift_loadmore_params.max_page == 0) {
      $('#postsContainer').text('No results were found. Try using different filters.');
    }
  }

  $("#post_roll_filters .top-level button").on("click", function(e) {
    e.preventDefault();
  })

    $("#post_roll_filters input").on("click", function(e) {
    
      let term_name = $(this).data('term-name');
      let term_name_no_underscores = term_name.replaceAll('_',' ');
      let filter_type = `${this.name}`;
      let filter_id = `${this.name}-${this.value}`;
      let filter_value = $(this).attr("id");

      if($(this).prop('checked') && $(this).attr("id") != 'featured'&& $(this).attr("id") != 'most_recent')  {
        $(".post-roll--filter-bar").addClass('active');
        $(".post-roll-filter-bar--filters").prepend(`<span class="inserted-filter" data-input-match="${filter_value}" id="${filter_id}">${term_name}<svg xmlns="http://www.w3.org/2000/svg" width="10.745" height="11.083" viewBox="0 0 10.745 11.083"><g id="Group_3386" data-name="Group 3386" transform="translate(-532.274 -524.585)"><path id="Path_1162" data-name="Path 1162" d="M1040.209,54l4.6,4.846L1049.5,54" transform="translate(1582.502 588.973) rotate(180)" fill="none" stroke="#000" stroke-width="2"/><path id="Path_1163" data-name="Path 1163" d="M1040.209,54l4.6,4.846L1049.5,54" transform="translate(-507.209 471.281)" fill="none" stroke="#000" stroke-width="2"/></g></svg></span>`);
      } else if($(this).prop('checked') && $(this).attr("id") == "featured") {
          $('#featured').prop('checked', true);
      } else if($(this).prop('checked') && $(this).attr("id") == "most_recent") {
        $('#most_recent').prop('checked', true);
      } else if ($(this).prop('checked', false)){
          $(`#${filter_id}`).remove();
      } 

      $("#post_roll_filters").submit();
      updateURLParam(filter_value, filter_type);
  });

  // This function fires when interacting with the active filters bar
  $('.post-roll--filter-bar').on('click', '.inserted-filter' , function() {
    let input_match = $(this).data("input-match");
    $(this).remove();
    console.log(this, 'Firing the filters');
    $('#post_roll_filters').find('#'+input_match).prop('checked', false).attr("checked", false)
    console.log($('#post_roll_filters').find('#'+input_match).prop('checked', false).attr("checked", false));
    
    $('#post_roll_filters').submit();
  });

  // This is the clear all filters button functionality
  let clear_filters = function() {
      $('#filter-bar--mobile-button span.count').text('');
      $('#filter-bar--mobile-button').css('justify-content', 'center')
      $('#post_roll_filters').find('input:checked').prop('checked', false).attr("checked", false);
      $('#post_roll_filters').removeClass('active');
      $('.panel').removeClass('open');
      $('.top-level').removeClass('open');
      $('.post-roll--filter-bar').removeClass('active');
      $('.post-roll--filter-bar .inserted-filter').each(function() {
        let input_match = $(this).data("input-match");
        $(this).remove();
        $('#post_roll_filters').find('#'+input_match).prop('checked', false).attr("checked", false);
        $('#post_roll_filters').find('#featured').prop('checked', true).attr('checked',true);
      });    
    dayshift_loadmore_params.current_page = 1;
    $('#post_roll_filters').submit();
  }

  // Call clean_filters function and cleanup extra classes
  $('.post-roll-filter-bar--clear-filters-button').on('click', function() {
    clear_filters();
    $('body').removeClass('filter-open');
    $('.not-popup-filters').removeClass('hide');
  });

  // Submit the form, call filtersAjax function
  $("#post_roll_filters").submit(function (e) {
        e.preventDefault();
        filtersAjax($(this));
  });

  // Read URL vars for query 
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // Simulate click on the author that should be selected to run filter
  const author = urlParams.get('authors');
  if(author != null){
    let preFilter = document.getElementById(author);
    let preFilterLabel = document.getElementById(author + "_label");
    setTimeout(function(){$(preFilter).trigger("click");console.log(author);}, 300);
  }

  // Simulate click on the category that should be selected to run filter
  const category = urlParams.get('categories');
  if(category != null){
    let preFilterCategory = document.getElementById(category);
    let preFilterCategoryLabel = document.getElementById(category + "_label");
    setTimeout(function(){$(preFilterCategory ).trigger("click");console.log(category);}, 300);
  } else {
    // If there is no category url parameter then run a check to see if there is a primary category dataset and click that category
    // Get the data attribute from the grid to check the primary category and then simulate click on that primary category
    const postsContainer = document.getElementById("postsContainer");
    if(postsContainer != null){
      let featuredCategory = postsContainer.dataset.primaryCategory;
      if(featuredCategory == 'pov'){
        featuredCategory = 'points_of_view'; //Fix the slug for povs so it matches the filter button
      }
      if(featuredCategory != null || featuredCategory != ''){
        let preFilterCategory = document.getElementById(featuredCategory);
        setTimeout(function(){$(preFilterCategory).trigger("click");console.log(featuredCategory);}, 300);
      }
    }
  }

  let filtersAjax = function(filters) {

    console.log("Filters ajax firing");

    let clear_active;
    let allTheFilters = filters.serializeArray();
    let number_of_active_filters = allTheFilters.length;

    $('#filter-bar--mobile-button span.count').text("(" + number_of_active_filters + ")");
    $('#filter-bar--mobile-button--popup-filters span.count').text("(" + number_of_active_filters + ")");

    if(number_of_active_filters == 0) {
      $('.company-archive--filter-bar').removeClass('active');
      $('#filter-bar--mobile-button span.count').text("(" + number_of_active_filters + ")");
    }

    clear_active = false;

    if(number_of_active_filters == 0) {
      $('.post-roll--filter-bar').removeClass('active');
      $('#filter-bar--mobile-button span.count').text("");
      $('#filter-bar--mobile-button').css('justify-content', 'center')
      $('#filter-bar--mobile-button--popup-filters span.count').text("");
      $('#filter-bar--mobile-button--popup-filters').css('justify-content', 'center');
      allTheFilters = $('.post-roll-filters').data('load-in-catagories');
      clear_active = true;
    } else if(number_of_active_filters >= 1) {
      $('#filter-bar--mobile-button').css('justify-content', 'space-between');
      $('#filter-bar--mobile-button--popup-filters').css('justify-content', 'space-between');
    }

    // Check if posts are set to Featured or Most Recent
    // Get the featured button object
    var sort_button_featured = document.getElementById('featured');
    var sort_button_recent = document.getElementById('most_recent');
    if(sort_button_featured != null){
      if(document.getElementById('featured').checked){
        var isFeatured = 'true';
      }
    } else if(sort_button_recent != null){
      if(document.getElementById('most_recent').checked){
        var isFeatured = 'false';
      }
    } else {
      var isFeatured = null;
    }

    // Added a new clear state variable so we know if the user is clearing the filters.
    let load_in_categories = $('.post-roll-filters').data('load-in-catagories');

    //console.log('query vars before ajax ' + dayshift_loadmore_params.query_vars);

    $.ajax({
      url: dayshift_loadmore_params.ajaxurl,
      data: {
        action: "post_roll_filter",
        query_vars: dayshift_loadmore_params.query_vars,
        params: allTheFilters,
        current_page: dayshift_loadmore_params.current_page,
        load_in_categories: load_in_categories,
        featured_posts: isFeatured,
        clear_state: clear_active
      },
      dataType: "json",
      type: "POST",
      beforeSend: function () {
      },
      error: function (result) {
        console.warn("error on filter", result);
      },
      success: function (result) {
        // console.log('load_in_categories is ' + load_in_categories);
        console.log("Filters AJAX success result");
        showPosts(result); 
      }
    })
  }

  // Get and check parameters in the URL to set filters on page load
  let paramCheck = function() {
    
    let params = (new URL(document.location)).searchParams;
    let type = params.get('categories');

    $('#post_roll_filters').find('#'+type).click();
    $('#post_roll_filters').submit();
  }

  // paramCheck is firing everytime even if there are no url arguments, and resetting the query when not needed
  // TODO: Update the function to only run when needed to prevent reloading the query and messing up initial post load in some circumstances
  // paramCheck();
}